import React, { useEffect, useState } from "react";
import BookConsultationModal from "./BookConsultationModal";
import { BOOK_EVENT } from "../lib/bookConsultation";

export default function BookConsultationProvider() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(BOOK_EVENT, handler);
    return () => window.removeEventListener(BOOK_EVENT, handler);
  }, []);

  return <BookConsultationModal open={open} onClose={() => setOpen(false)} />;
}
